<div class="modal-wrapper">
  <div class="overlay" *ngIf="loading$ | async">
    <app-spinner></app-spinner>
  </div>
  <div class="modal-body drill-down-body">
    <div class="drill-down-title">
      <h4>Company Drill Down</h4>
      <div>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
        <span class="resize" role="button" tabindex="0" aria-label="full screen" (click)="resize()" title="Toggle full width mode">
          <i class="material-icons" *ngIf="!isFullScreen"> fullscreen </i>
          <i class="material-icons" *ngIf="isFullScreen"> fullscreen_exit </i>
        </span>
      </div>
    </div>
    <div class="drill-down-details">
      <app-company-slide-out-drill-down></app-company-slide-out-drill-down>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="close()">Close</button>
  </div>
</div>
